import jwtDecode from 'jwt-decode'
import Auth from '@aws-amplify/auth'
export const SIGN_IN = 'signin'
export const SIGN_OUT = 'signout'
export const LOGGED_IN = 'login'
export const LOAD_SETTINGS = 'load_settings'
export const LOAD_TENANT = 'load_tenant'
export const LOAD_COMPANY_PROFILE = 'load_company_profile'

export function signin(user) {

  localStorage.setItem('pos-session', JSON.stringify(user))
  localStorage.setItem('tenant', (user && user.signInUserSession &&
    user.signInUserSession.idToken) ? jwtDecode(user.signInUserSession.idToken.jwtToken)['custom:tenant']
    : null)

  return {
    type: SIGN_IN,
    payload: (user && user.signInUserSession) ?
      jwtDecode(user.signInUserSession.idToken.jwtToken) :
      null
  }
}

export function signout() {
  
  Auth.signOut()
    .then(data => null)
    .catch(err => console.log(err));
  localStorage.clear()
  sessionStorage.clear()
  return {
    type: SIGN_OUT
  }
}

export function loadSettings(settings) {

  return {
    type: LOAD_SETTINGS,
    payload: settings
  }
}

export function loadCompanyProfile(companyProfile) {

  return {
    type: LOAD_COMPANY_PROFILE,
    payload: companyProfile
  }
}

export function loadTenant(tenant) {

  return {
    type: LOAD_TENANT,
    payload: tenant
  }
}

export const hasLoggedIn = user => async dispatch => {
  let _user = user
  const hasLoggedIn = _user &&
    _user['custom:hasLoggedIn'] &&
    _user['custom:hasLoggedIn'].toLowerCase()

  if (hasLoggedIn === 'false') {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser()
      await Auth.updateUserAttributes(cognitoUser, { 'custom:hasLoggedIn': 'true' });
      _user['custom:hasLoggedIn'] = 'true'
      localStorage.setItem('pos-session', JSON.stringify(_user))

      dispatch({ type: LOGGED_IN, payload: _user })
    } catch (e) {
      console.log(e)
      dispatch({ type: LOGGED_IN, payload: _user })
    }
  } else {
    dispatch({ type: LOGGED_IN, payload: _user })
  }


}


// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js